import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { useGetSeoPageData } from 'src/hooks/useGetSeoPageData';

export const PageHeadSEO = () => {
  const { pathname } = useLocation();
  const seoPageData = useGetSeoPageData();

  return (
    <Helmet>
      {seoPageData?.title && <title>{seoPageData.title}</title>}
      {seoPageData?.description && <meta name="description" content={seoPageData.description} />}
      {seoPageData && pathname && <link rel="canonical" href={pathname} />}
    </Helmet>
  );
};
